import crypto from 'crypto';

function generateDigest(request) {
  const buffer = Buffer.from(JSON.stringify(request), 'utf8');

  const hash = crypto.createHash('sha256');

  hash.update(buffer);

  const digest = hash.digest('base64');

  return digest;
}

export default generateDigest;
